import { useEffect, useRef } from 'react';
import { useIFramePageContext, iframePageInitialState } from '../contexts';
export var useIFramePage = function (_a) {
    var _b = _a.header, header = _b === void 0 ? iframePageInitialState.header : _b, _c = _a.headerContainer, headerContainer = _c === void 0 ? iframePageInitialState.headerContainer : _c, _d = _a.closeButton, closeButton = _d === void 0 ? iframePageInitialState.closeButton : _d, _e = _a.onClose, onClose = _e === void 0 ? iframePageInitialState.onClose : _e, iframeUrl = _a.iframeUrl, isLoading = _a.isLoading;
    var isActive = useRef(false); // If this iframe hook is opened, begin tracking changes to isLoading and iframeUrl
    var _f = useIFramePageContext(), disclosure = _f.disclosure, setHeader = _f.setHeader, setHeaderContainer = _f.setHeaderContainer, setOnClose = _f.setOnClose, setCloseButton = _f.setCloseButton, setIFrameUrl = _f.setIFrameUrl, setIsLoading = _f.setIsLoading;
    var open = function () {
        isActive.current = true;
        setHeader(header);
        setHeaderContainer(headerContainer);
        setIFrameUrl(iframeUrl);
        setOnClose(function () {
            isActive.current = false;
            if (onClose) {
                onClose();
            }
        });
        setCloseButton(closeButton);
        disclosure.onOpen();
    };
    var close = function () {
        disclosure.onClose();
    };
    useEffect(function () {
        if (isActive.current) {
            setIFrameUrl(iframeUrl);
        }
    }, [iframeUrl]);
    useEffect(function () {
        if (isActive.current) {
            setIsLoading(!!isLoading);
        }
    }, [isLoading]);
    return {
        open: open,
        close: close,
        isOpen: disclosure.isOpen,
    };
};
